import { combineReducers } from "@reduxjs/toolkit";

// Reducers are imported from their slice files rather than feature barrels to
// keep the Storybook preview's dependency graph small. Chromatic TurboSnap
// falls back to a full rebuild when anything imported (transitively) by
// .storybook/preview.tsx changes, and the barrels drag in routes and pages.
import { classReducer } from "@/data/class/classSlice";
import { errorReducer } from "@/data/error/errorSlice";
import { localFlagsReducer } from "@/data/localFlags/localFlagsSlice";
import { taskReducer } from "@/data/task/taskSlice";
import { markReducer } from "@/features/marking/store/mark-slice";
import { moderateReducer } from "@/features/moderation/moderate-slice/moderate-slice";
import { questionFormValidationReducer } from "@/features/multi-format/question-form-validation/slice";
import { taskLayoutReducer } from "@/features/multi-format/task-layout/slice";
import { questionImportReducer } from "@/features/question-library-file-import/data/slice";

import { templatesReducer } from "./templates/templatesSlice";

export const rootReducer = combineReducers({
  error: errorReducer,
  task: taskReducer,
  templates: templatesReducer,
  class: classReducer,
  localFlags: localFlagsReducer,
  taskLayout: taskLayoutReducer,
  questionFormValidation: questionFormValidationReducer,
  questionImport: questionImportReducer,
  mark: markReducer,
  moderate: moderateReducer,
});
